import { useDisclosure } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import '../../App.css';
import Alerta from '../../components/Alerta/Alerta';
import AlertaConfirmacao from '../../components/AlertaConfirmacao/AlertaConfirmacao';
import BarraBotoes from '../../components/BarraBotoes/BarraBotoes';
import FormPadrao from '../../components/FormPadrao/FormPadrao';
import Pagina from '../../components/Pagina/Pagina';
import Tabela from '../../components/Tabela/Tabela';
import api from '../../services/api';
import './CentrosCustos.css';

function ListarCentrosCustos() {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: false });
  const [alertStatus, setAlertStatus] = useState('success');
  const {
    isOpen: isOpenExcluir,
    onOpen: onOpenExcluir,
    onClose: onCloseExcluir,
  } = useDisclosure({
    defaultIsOpen: false,
  });
  const [alertTitle, setAlertTitle] = useState('');
  const [message, setMessage] = useState('');
  const [selectedItem, setSelectedItem] = useState('');

  const [centrosCustos, setCentrosCustos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchBar, setSearchBar] = useState('');

  useEffect(() => {
    async function GetCentrosCustos() {
      let payload = {
        database: localStorage.getItem('database'),
        data: '',
      };
      let res = await api.post('/ListCentroCustos/Get', payload);
      if (res.status === 200) {
        let data = res.data;
        data.CentroCustos.forEach(b => {
          b.Selecionado = false;
        });
        setCentrosCustos(data.CentroCustos);
        setLoading(false);
      } else {
        alert('Erro ao buscar dados');
      }
    }
    GetCentrosCustos();
  }, []);

  function handleEdit(item) {
    navigate(`/CentrosCustos/Editar/${item.Id}`);
  }

  function handleClick() {
    navigate('/CentrosCustos/Editar');
  }

  function handleDelete(item) {
    setSelectedItem(item.Id);
    setAlertTitle('Excluir');
    setMessage('Deseja excluir o centro de custo?');
    onOpenExcluir();
  }

  let deleteItem = async () => {
    let payload = {
      data: selectedItem,
      database: localStorage.getItem('database'),
    };
    let res = await api.post('/ListCentroCustos/Delete', payload);
    let data = res.data;
    onCloseExcluir();
    if (data.Success) {
      setAlertStatus('success');
      setAlertTitle(data.MSG);
      onOpen();
    } else {
      setCentrosCustos(centrosCustos.filter(item => item.Id !== selectedItem));
      setAlertStatus('error');
      setAlertTitle(data.MSG);
      onOpen();
    }
  };

  return (
    <>
      <AlertaConfirmacao
        isOpen={isOpenExcluir}
        onClose={onCloseExcluir}
        description={message}
        title={alertTitle}
        onConfirm={() => deleteItem()}
      />
      <Alerta
        isOpen={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        alertStatus={alertStatus}
        title={alertTitle}
      />
      <Pagina loading={loading}>
        <FormPadrao>
          <BarraBotoes
            botoes={[
              {
                children: 'Novo',
                onClick: handleClick,
                variant: 'turquesa',
              },
            ]}
            search={{
              placeholder: 'Procurar por centros de custos',
              onChange: e => setSearchBar(e.target.value),
            }}
          />
          <Tabela
            titulo={'LISTAGEM DE CENTROS DE CUSTO'}
            setFunction={setCentrosCustos}
            data={centrosCustos}
            columns={[
              {
                placeholder: 'NOME',
                name: 'Nome',
                type: 'text',
              },
              {
                placeholder: 'HIERARQUIA',
                name: 'CentroPai',
                type: 'text',
              },
            ]}
            searchBar={searchBar}
            handleEdit={handleEdit}
            useCheck={false}
            handleDelete={handleDelete}
            showDelete={true}
          />
        </FormPadrao>
      </Pagina>
    </>
  );
}

export default ListarCentrosCustos;
